import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import { useHistory } from 'react-router-dom'

import menuText from '../../constants/Menu'
import text from '../../constants/ListCompras'
import Header from '../../components/Header'

import '../../styles/containers/ListComprasCategory.css'
import { FiArrowLeft, FiChevronRight } from 'react-icons/fi'
import useLanguage from '../../hooks/useLanguage'

const calculateQuantity = (name, user) => {
  let length = 0
  if (user.shopListTemplate) {
    user.shopListTemplate.forEach(product => {
      if (product.category.toLowerCase() === name.toLowerCase().replace(' ', '')) {
        length++
      }
    })
  }
  return length
}

const OptionMenu = ({ name, language, image, history, path, notification, categoryLabel, user }) => {
  return (
    <div className='list-compras-category-option' style={{ backgroundImage: `url(../${image})`, backgroundSize: 'cover' }} onClick={() => history.push({ pathname: path, state: { category: categoryLabel, nameCategory: `${name[language]}` } })}>
      <div className='compras-opacity' />
      <div className='compras-content'>
        <div className='compras-name'>{name[language]} ({calculateQuantity(categoryLabel, user)})</div>
        <div className='compras-right'>
          {notification && <div className='compras-notification'>
            notification
          </div>}
          <FiChevronRight color='white' size={24} style={{ marginRight: 16, paddingTop: 4 }} />
        </div>
      </div>
    </div>
  )
}

const ComprasCategory = props => {
  const history = useHistory()

  const language = useLanguage()

  return (
    <div className='list-compras-category-container'>
      <Header language={language} />
      <div className='list-compras-category-title'>
        <FiArrowLeft onClick={() => history.push('/')}
          size={24} color='var(--primary)' className='perfil-screen-goback' />
        <p>{menuText.list[language]}</p>
      </div>
      { props.user.universe === 'masculine'
        ? <div className='list-compras-category-options'>
          <OptionMenu name={text.upperPart} categoryLabel='upperpart' language={language} image='assets/upperPartMasculine.jpg' history={history} path={`/compras`} user={props.user} />
          <OptionMenu name={text.lowerPart} categoryLabel='lowerpart' language={language} image='assets/lowerPartMasculine.jpg' history={history} path={`/compras`} user={props.user} />
          <OptionMenu name={text.accessories} categoryLabel='accessories' language={language} image='assets/accessoriesComprasMasculine.jpg' history={history} path={`/compras`} user={props.user} />
          <OptionMenu name={text.shoes} categoryLabel='shoes' language={language} image='assets/shoesMasculine.jpeg' history={history} path={`/compras`} user={props.user} />
          <OptionMenu name={text.other} categoryLabel='other' language={language} image='assets/otherMasculine.jpg' history={history} path={`/compras`} user={props.user} />
        </div>
        : <div className='list-compras-category-options'>
          <OptionMenu name={text.upperPart} categoryLabel='upperpart' language={language} image='assets/upperPart.jpeg' history={history} path={`/compras`} user={props.user} />
          <OptionMenu name={text.lowerPart} categoryLabel='lowerpart' language={language} image='assets/lowerPart.jpeg' history={history} path={`/compras`} user={props.user} />
          <OptionMenu name={text.accessories} categoryLabel='accessories' language={language} image='assets/accessoriesCompras.jpeg' history={history} path={`/compras`} user={props.user} />
          <OptionMenu name={text.shoes} categoryLabel='shoes' language={language} image='assets/shoes.jpeg' history={history} path={`/compras`} user={props.user} />
          <OptionMenu name={text.makeup} categoryLabel='makeup' language={language} image='assets/makeup.jpg' history={history} path={`/compras`} user={props.user} />
          <OptionMenu name={text.other} categoryLabel='other' language={language} image='assets/other.jpeg' history={history} path={`/compras`} user={props.user} />
        </div>
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(ComprasCategory)



// WEBPACK FOOTER //
// ./src/containers/ListCompras/ListComprasCategory.js